{
  "el": {
    "validation": {
      "emailAddressDemo": "Η διεύθυνση email μιας επαφής σε αυτόν τον δοκιμαστικό οργανισμό πρέπει να τελειώνει σε '{email_address_suffix}' ή '{'@'}ziggu.io'",
      "emailTaken": "Η διεύθυνση email χρησιμοποιείται ήδη",
      "errorsInLanguages": "Ορισμένες μεταφράσεις έχουν σφάλματα, έλεγξε: {languages}",
      "import": {
        "inclusion": "Σφάλμα στη γραμμή {rowNumber} στήλη {columnNumber}: το {headerName} δεν περιλαμβάνεται στη λίστα",
        "inclusion_values": "με επιτρεπόμενες τιμές: {values}",
        "invalid": "Σφάλμα στη γραμμή {rowNumber} στήλη {columnNumber}: το {headerName} δεν είναι έγκυρο",
        "required": "Σφάλμα στη γραμμή {rowNumber} στήλη {columnNumber}: απαιτείται τιμή για το {headerName}",
        "unique": "Σφάλμα στη γραμμή {rowNumber}: το {headerName} δεν είναι μοναδικό, υπάρχει άλλη γραμμή με την ίδια τιμή"
      },
      "nameAlreadyTaken": "Το όνομα χρησιμοποιείται ήδη",
      "needCompany": "Ο οργανισμός είναι υποχρεωτικός",
      "needName": "Το όνομα είναι υποχρεωτικό"
    }
  }
}
